import styled from 'styled-components';
import { nuDSColor } from '@nubank/nuds-web/styles/themeUtils';

export const CollapseContainer = styled.div`
  border-top: 2px solid ${nuDSColor('black')};
`;

CollapseContainer.displayName = 'CollapseContainer';
